module.exports = __webpack_public_path__ + "static/media/11.8d235e2d.jpg";